const NotFound = ({ message }: { message?: string }) => {
  return (
    <>
      <h1>404 NotFound</h1>
      {message}
    </>
  );
};
export default NotFound;
